import React from 'react';
import { Zap, Shield, Lock, MessageCircle } from 'lucide-react';
import { whyChooseUs } from '../utils/mockData';

const iconMap = {
  Zap,
  Shield,
  Lock,
  MessageCircle
};

export const WhyUs = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#204FA7] mb-4">
            Pourquoi choisir Rapide Colis ?
          </h2>
          <p className="text-lg text-gray-600">
            Un service de qualité qui fait la différence
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="text-center group"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#204FA7] to-[#1CA1CC] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                  <IconComponent className="text-white" size={36} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 bg-gradient-to-r from-[#204FA7] to-[#1CA1CC] rounded-2xl p-8 sm:p-12 text-center text-white shadow-xl">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4">
            Prêt à expédier votre colis ?
          </h3>
          <p className="text-lg mb-8 text-white/90">
            Contactez-nous maintenant via WhatsApp pour un devis gratuit
          </p>
          <a 
            href="https://wa.me/33695701735?text=Bonjour,%20je%20souhaite%20obtenir%20un%20devis"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-white text-[#204FA7] px-8 py-4 rounded-lg hover:bg-gray-100 transition-colors font-semibold shadow-lg hover:shadow-xl"
          >
            <MessageCircle size={20} />
            <span>Demander un devis</span>
          </a>
        </div>
      </div>
    </section>
  );
};
